import BaseViewExtensionViewFactory from '@/Factories/ViewFactories/BaseViewExtensionViewFactory';
import StartpageViewModelT from '@/ViewModels/Views/StartpageViewModel';
import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
export default class StartpageViewFactory extends BaseViewExtensionViewFactory {
    public viewModel: any;
    public view: any;
    private StartpageViewModel: any;
    private StartpageView: any;
    constructor(params: any) {
        super($.extend({ Title: 'Home', viewModelName: 'StartpageViewModel', viewName: 'StartpageView', viewElementName: 'Startpage' }, params));
        this.StartpageViewModel = ComponentManager.getViewModel<typeof StartpageViewModelT>('StartpageViewModel');
        this.StartpageView = ComponentManager.getView('StartpageView');
    }
    public getRegion(): string {
        return 'Content';
    }
    public getView(): any {
        this.resolveDependencies(['Wireframe']);
        if (this.viewModel == null || this.viewModel.isDisposed) {
            this.viewModel = new this.StartpageViewModel({
                locator: 'startpage',
                viewFactory: this
            });
        }
        if (this.view == null) {
            this.view = new this.StartpageView(this.viewModel, this.createRootElement('Startpage'));
        }
        this.setPageTitle('Home');
        let tuple = this.view.getTuple();
        return tuple.view;
    }
}

ComponentManager.setFactory('Startpage', StartpageViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('StartpageView', StartpageViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');